import { ShowLoveOptionsType } from './types';

export const SHOW_LOVE_OPTIONS: ShowLoveOptionsType = [
  { id: 'physical_touch', title: 'Physical touch', icon: '🤗' },
  { id: 'words_affirmation', title: 'Words of affirmation', icon: '💬' },
  { id: 'acts_service', title: 'Acts of service', icon: '🫶' },
  { id: 'spicy_surprises', title: 'Spicy surprises', icon: '🔥' },
  { id: 'quality_time', title: 'Quality time', icon: '💦' },
];
